// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__DdgYt","section-1":"styles_section-1__gNADY","content":"styles_content__Bb2EJ","section-2":"styles_section-2__XZCnX"};